"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Text = require("../Text");

var _Util = require("../Util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = _reactNative.StyleSheet.create({
  TouchableOpacity: {
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#fff',
    paddingHorizontal: 10,
    paddingVertical: 5,
    paddingTop: 9
  }
});

var _default = function _default(_ref) {
  var _ref$onPress = _ref.onPress,
      onPress = _ref$onPress === void 0 ? function () {} : _ref$onPress,
      title = _ref.title,
      timer = _ref.timer,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ["onPress", "title", "timer", "style"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, _extends({}, props, {
    onPress: onPress,
    style: [styles.TouchableOpacity, style]
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 22,
      fontWeight: 'bold'
    }
  }, title), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 30,
      fontWeight: 'bold'
    }
  }, (0, _Util.renderTime)(timer, 'short')));
};

exports["default"] = _default;